const LISTE_FOURNISSEUR_MATERIEL = {
  title: 'Liste des fournisseurs matériel',
  actions: {
    add: 'Nouveau fournisseur matériel',
    search: 'Recherche',
    filtre: 'Filtre',
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    fournisseurs: 'Fournisseur(s) de matériel',
    archive: 'Archivé',
    yes: 'Oui',
    no: 'Non',
    actions: {
      search: 'Rechercher',
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
  },
  breadcrumb: {
    liste: 'Liste des fournisseurs matériel',
  },
  tab: {
    code: 'Code',
    raisonSocial: 'Raison sociale',
    adresse: 'Adresse',
    cp: 'CP',
    ville: 'Ville',
    telephone: 'Téléphone',
    portable: 'Portable',
    email: 'Email',
    compteComptable: 'Code comptable',
  },
};

export default LISTE_FOURNISSEUR_MATERIEL;
